"use client";

import { DropdownMenuTrigger } from "@radix-ui/react-dropdown-menu";
import { Table } from "@tanstack/react-table";

import { Button } from "@/app/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from "@/app/components/ui/dropdown-menu";
import accessorKeyHeaderRecord from "./accessorKeyHeaderRecord";
import { ColumnsIcon } from "@radix-ui/react-icons";

interface DataTableViewOptionsProps<TData> {
  cacheKey?: string;
  table: Table<TData>;
  headerMap?: Record<string, string>;
}

const hiddenColumns = ["type", "unsoldLots", "payoutAmount"];
export function DataTableViewOptions<TData>({
  cacheKey = "columnVisibility",
  table,
  headerMap = accessorKeyHeaderRecord
}: DataTableViewOptionsProps<TData>) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" className="ml-auto hidden h-8 lg:flex">
          <ColumnsIcon className="h-4 w-4 mr-2" />
          Columns
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-[150px]">
        <DropdownMenuLabel className="text-xs">
          Toggle columns
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {table
          .getAllColumns()
          .filter(
            (column) =>
              typeof column.accessorFn !== "undefined" &&
              column.getCanHide() &&
              !hiddenColumns.includes(column.id)
          )
          .map((column) => {
            const label = headerMap[column.id] ?? column.id;
            return (
              <DropdownMenuCheckboxItem
                key={column.id}
                className="capitalize text-xs"
                checked={column.getIsVisible()}
                onCheckedChange={(value) => {
                  column.toggleVisibility(!!value);

                  localStorage.setItem(
                    cacheKey,
                    JSON.stringify({
                      ...table.getState().columnVisibility,
                      [column.id]: !!value,
                    })
                  );
                }}
                onSelect={(event) => event.preventDefault()}
              >
                {label}
              </DropdownMenuCheckboxItem>
            );
          })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
